/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { Component, inject} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Params} from "@angular/router";
import {FabUser} from '@fabric/common/types';
import { TranslateService } from '@ngx-translate/core';
import {OAuthService} from 'angular-oauth2-oidc';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import {VIEW_AUTHORITY} from './common/constants';
import {AuthenticationService} from './core/auth/authentication.service';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import {UserInfo} from './model/user-info';
import {UserAuthService} from './services/user-auth.service';
import {UserService} from './services/user/user.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    standalone: false
})
export class AppComponent {
	sidebarOpen: boolean = false;
	title = 'GM Proving Ground Automation';
	needFullPage=true;
  public user: FabUser = inject(UserService).user ?? ({} as FabUser);
  public userAuthorities: string[] = [];
  public readonly adminView: string = 'admin-view';
  public readonly userView: string = 'user-view';
  public userInfo:UserInfo

	constructor(private readonly userService: UserService, private readonly oauthService: OAuthService, private readonly authService: AuthenticationService,private readonly http: HttpClient,private readonly route: ActivatedRoute, private readonly translate: TranslateService, private readonly router: Router, private readonly location: Location, private readonly userAuthService: UserAuthService) {
    inject(AuthenticationService).enableSilentRenew();
    translate.setDefaultLang('en');
    translate.use('en');

    if(this.user.roles) {
      this.userService.setUserAuthorities(this.user.roles);
      this.configUserInfo();
    }
  }

  configUserInfo(): void {
    this.user = this.userService.user;
    if(this.user.authorities) {

      this.userAuthorities = this.user.authorities;
      this.authService.setAuthorities(this.userAuthorities)
    }
    this.userAuthService.setUser(this.user)
    this.authService.setUser(this.user)

  }

  async verifyUser(): Promise<boolean> {
    return this.userService.hasAnyAuthorities([VIEW_AUTHORITY.adminAuthority, VIEW_AUTHORITY.userAuthority]);
  }


	openSidebar(isOpen: boolean): void {
		this.sidebarOpen = isOpen || false;
	}

	closeSidebar(){
		this.sidebarOpen = false;
	}

	ngOnInit(): void {
    this.route.queryParams?.subscribe((params: Params)=>{
      if(params['modalpopup']!=undefined){
        this.needFullPage=false;
      }
      else
        this.needFullPage=true;
    });
  }





  ngOnDestroy(): void {
    console.log('Component destroyed');
  }
}
